import { useMemo, useState } from "react";
import MangaCard from "@/components/feature/MangaCard";
import { mangaList } from "@/mocks/manga";

const filters = [
  { key: "all", label: "全部" },
  { key: "连载中", label: "连载中" },
  { key: "已完结", label: "已完结" },
];

export default function NewUpdates() {
  const [active, setActive] = useState("all");

  const list = useMemo(() => {
    const filtered = active === "all" ? mangaList : mangaList.filter((m) => m.status === active);
    return [...filtered].slice(0, 9);
  }, [active]);

  return (
    <section id="new" className="mx-auto w-full max-w-[1400px] px-4 py-14 md:py-20">
      <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-refresh-line"></i>
            最新更新
          </span>
          <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">新章节刚刚上架</h2>
          <p className="mt-2 text-[15px] text-foreground-600">
            热门连载与完结佳作实时更新，追更不迷路，脸红不停歇。
          </p>
        </div>
        <div className="flex items-center gap-1 rounded-full border border-background-200 bg-background-50 p-1">
          {filters.map((f) => (
            <button
              key={f.key}
              type="button"
              onClick={() => setActive(f.key)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                active === f.key
                  ? "bg-primary-500 font-medium text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        {list.map((manga) => (
          <MangaCard key={manga.id} manga={manga} />
        ))}
      </div>
    </section>
  );
}